import React from 'react';
import {
  useTheme,
  useMediaQuery,
  Box,
  Grid,
  Typography,
  TextField,
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import Button from '../../components/button';
import { SectionHeader } from '../../components/sectionHeader';

const useStyles = makeStyles(theme =>
  createStyles({
    textField: {
      width: '100%',
    },
  })
);

const ContactUsSection = () => {
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useStyles();
  return (
    <Box
      width="100%"
      position="relative"
      px={isMobile ? '24px' : '64px'}
    >
      <SectionHeader
        title="सम्पर्क गर्नुहोस"
        id="contact-us"
        lineBottom
      />
      <Grid container justify="center">
        <Typography variant="body1" gutterBottom>
          Thanks for getting in touch.
        </Typography>
      </Grid>
      <form
        name="Contact Form"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="Contact Form" />
        <Box
          width={1}
          // height={1}
          py="24px"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Box py="8px" width={!isMobile ? '50%' : '100%'}>
            <Typography variant="body1">Your Name *</Typography>
            <TextField
              required
              type="name"
              name="name"
              className={classes.textField}
              margin="normal"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>
          <Box py="8px" width={!isMobile ? '50%' : '100%'}>
            <Typography variant="body1">Your Email *</Typography>
            <TextField
              required
              type="email"
              name="email"
              className={classes.textField}
              margin="normal"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>
          <Box py="8px" width={!isMobile ? '50%' : '100%'}>
            <Typography variant="body1" gutterBottom>
              Your Message *
            </Typography>
            <TextField
              required
              type="message"
              name="message"
              className={classes.textField}
              margin="normal"
              variant="filled"
              multiline
              rows="10"
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>
          <Box display="flex" justifyContent="center" mb="24px">
            <Button size="large" type="submit" primary>
              {'Send'}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default ContactUsSection;
